import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

export function EmailValidator() {
  const emailRegex = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9]+([-.][a-zA-Z0-9]+)*\\.[a-zA-Z]{2,}$';

  return (control: AbstractControl): ValidationErrors | null => {
    if (Validators.pattern(emailRegex)(control)) {
      return { email: true };
    }

    if (Validators.minLength(5)(control) || Validators.maxLength(64)(control)) {
      return {
        length: {
          min: 5,
          max: 64,
        },
      };
    }

    return null;
  };
}
